import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    this.state = false
    this.hamburgers = document.querySelectorAll('.c-burger')
    this.hamburgers.forEach(hamburger => {
      hamburger.setAttribute('role', 'button')
      hamburger.setAttribute('aria-expanded', false)
      hamburger.addEventListener('click', () => {
        const aria = JSON.parse(hamburger.getAttribute('aria-expanded'))
        hamburger.setAttribute('aria-expanded', !aria)
        document.body.classList.toggle('has-menu')
      })
    })

    const links = document.querySelectorAll('.c-header__menu a')
    links.forEach(link => {
      link.addEventListener('click', e => {
        if (link.classList.contains('disabled')) {
          e.preventDefault()

          if (
            document.referrer &&
            document.referrer.includes(window.origin) &&
            document.referrer !== window.location.href
          ) {
            window.location.href = document.referrer
          } else {
            window.location.href = '/'
          }
        }
      })
    })
  }

  toggleMenu () {
    if (this.state) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  async closeMenu () {
    this.state = false
    this.hamburgers.forEach(el => {
      el.setAttribute('aria-expanded', false)
    })
    document.body.classList.remove('has-menu')
  }

  async openMenu () {
    this.state = true
    this.hamburgers.forEach(el => {
      el.setAttribute('aria-expanded', true)
    })
    document.body.classList.add('has-menu')
  }
}
